export type PaneIndex = 0 | 1 | 2;

export function getInitialPane(pathname: string | undefined, routePrefix: string, persistedPane: PaneIndex | undefined): PaneIndex {
  const routePane = getPaneFromPath(pathname, routePrefix);
  if (routePane !== undefined) {
    return routePane;
  }

  return persistedPane !== undefined ? persistedPane : 0;
}

export function toPaneIndex(value: number): PaneIndex | undefined {
  if (value === 0 || value === 1 || value === 2) {
    return value;
  }

  return undefined;
}

function getPaneFromPath(pathname: string | undefined, routePrefix: string): PaneIndex | undefined {
  if (!pathname) {
    return undefined;
  }

  const escapedRoutePrefix = routePrefix.replace(/\//g, "\\/");
  const match = pathname.match(new RegExp(`${escapedRoutePrefix}\\/(\\d+)\\/?$`));
  if (!match || match.length !== 2) {
    return undefined;
  }

  return toPaneIndex(parseInt(match[1], 10));
}



// WEBPACK FOOTER //
// ./src/helpers/horizontalPaneState.ts